export enum SendToFolioTarget {
  Reservations = 1,
  Groups = 2
}
